export type AdsConsentState = "unset" | "accepted" | "rejected";

const STORAGE_KEY = "finnhouse_ads_consent_v1";

export const readAdsConsent = (): AdsConsentState => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "accepted" || raw === "rejected") return raw;
    return "unset";
  } catch {
    return "unset";
  }
};

export const writeAdsConsent = (value: Exclude<AdsConsentState, "unset">): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore write failures (private mode, disabled storage)
  }
};

export const clearAdsConsent = (): void => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
